"use client";

import { useState, useEffect } from "react";
import { editIcon } from "@public/icons";
import { toast } from "react-toastify";
import verify from "@src/api/services/verify";
import sendSms from "@src/api/services/sendSms";
import updateUser from "@src/api/services/updateUser";
import Image from "next/image";
import { useAuth } from "@src/contexts/AuthContext";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";

const Verify = ({ phone, setIsVerified, handleUserUpdate }) => {
  const [code, setCode] = useState("");
  const [timer, setTimer] = useState(119);
  const [showUserForm, setShowUserForm] = useState(false);
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    codeMelli: "",
    birthday: "",
  });

  const { saveToken } = useAuth();

  useEffect(() => {
    if (code.length === 5) {
      confirmCodeHandler({ preventDefault: () => {} });
    }
  }, [code]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prevTimer) => (prevTimer > 0 ? prevTimer - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleBirthdayChange = (date) => {
    setUserData((prevData) => ({
      ...prevData,
      birthday: date,
    }));
  };

  const resendCodeHandler = async () => {
    setTimer(180);
    try {
      await sendSms(phone);
    } catch (error) {
      toast.error(error.response?.data?.message);
    }
  };

  const validateCode = (code) => {
    if (code.length !== 5) {
      toast.error("کد تایید صحیح نیست");
      return false;
    }
    return true;
  };

  const confirmCodeHandler = async (e) => {
    e.preventDefault();
    if (validateCode(code)) {
      try {
        const { token, firstName, lastName, codeMelli } = await verify(phone, code);
        saveToken(token);
        toast.success("با موفقیت وارد شدید");
        if (!firstName || !lastName || !codeMelli) {
          setShowUserForm(true);
        } else {
          handleUserUpdate();
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "کد تایید نامعتبر است");
      }
    }
  };

  const handleUserSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateUser(userData);
      handleUserUpdate();
    } catch (error) {
      null;
    }
  };

  return (
    <div>
      {!showUserForm ? (
        <form onSubmit={confirmCodeHandler} className="flex flex-col gap-5 p-4">
          <label className="flex flex-col text-right">
            <span className="pb-2 text-gray-600">شماره موبایل</span>
            <div className="flex items-center justify-between rounded-md border bg-gray-100 p-3">
              <span>{phone}</span>
              <Image
                src={editIcon}
                alt="editIcon"
                onClick={() => setIsVerified(false)}
                className="cursor-pointer"
              />
            </div>
          </label>
          <label className="flex flex-col text-right">
            کد تایید
            <input
              type="text"
              name="otp"
              autoFocus
              autoComplete="one-time-code"
              inputMode="numeric"
              pattern="\d{5}"
              maxLength={5}
              className="mt-1 rounded-md border p-3 focus:ring-2 focus:outline-hidden"
              placeholder="کد تایید را وارد کنید"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
          </label>
          <button className="bg-blue w-full cursor-pointer rounded-lg py-3 text-white">ورود</button>
          <div className="cursor-pointer text-center">
            {timer > 0 ? (
              <span className="text-blue">
                ارسال مجدد کد تایید ({timer < 10 ? `0${timer}` : timer})
              </span>
            ) : (
              <span onClick={resendCodeHandler} className="text-blue cursor-pointer">
                ارسال مجدد کد تایید
              </span>
            )}
          </div>
        </form>
      ) : (
        <form onSubmit={handleUserSubmit} className="flex flex-col gap-5 p-4">
          <label className="flex flex-col text-right">
            نام
            <input
              type="text"
              className="mt-1 rounded-md border p-3"
              placeholder="نام خود را وارد کنید"
              value={userData.firstName}
              onChange={(e) => setUserData({ ...userData, firstName: e.target.value })}
            />
          </label>
          <label className="flex flex-col text-right">
            نام خانوادگی
            <input
              type="text"
              className="mt-1 rounded-md border p-3"
              placeholder="نام خانوادگی خود را وارد کنید"
              value={userData.lastName}
              onChange={(e) => setUserData({ ...userData, lastName: e.target.value })}
            />
          </label>
          <label className="flex flex-col text-right">
            کد ملی
            <input
              type="text"
              className="mt-1 rounded-md border p-3"
              placeholder="کد ملی خود را وارد کنید"
              value={userData.codeMelli}
              onChange={(e) => setUserData({ ...userData, codeMelli: e.target.value })}
            />
          </label>
          <label className="flex flex-col text-right">تاریخ تولد</label>
          <DatePicker
            multiple={false}
            calendar={persian}
            locale={persian_fa}
            value={
              Array.isArray(userData.birthday) && userData.birthday.length > 0
                ? userData.birthday[0]
                : userData.birthday
            }
            onChange={handleBirthdayChange}
            className="rounded-md border border-gray-300 p-2 focus:border-blue-500 focus:outline-hidden"
            placeholder="تاریخ تولد خود را انتخاب کنید"
            required={true}
          />
          <button className="w-full cursor-pointer rounded-lg bg-emerald-600 py-3 text-white">
            ثبت اطلاعات
          </button>
        </form>
      )}
    </div>
  );
};

export default Verify;
